import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'

export const getSubscriptionPlanUrlUtil = (subscriptionPlan) => {
  if (!subscriptionPlan) {
    return ROUTE_PATH.PREMIUM
  }
  return ROUTE_PATH.PREMIUM + `?plan=${subscriptionPlan}`
}
